export enum TRADEIN_SOURCE_TYPES {
    ico = 'ICO',
    kbb = 'KBB',
    manual = 'Manual Entry',
    subarugtp = 'SUBARUGTP'
}

export enum TRADEIN_ESTIMATE_METHODS {
    SD = 'SD',
    USER = 'USER',
    ico = 'ICO',
    kbb = 'KBB',
    manual = 'Manual Entry'
}

export enum SUMMARY_CARD_TEXTS {
    appliedValue = 'Applied Value',
    estValue = 'Est. Value',
    valuePendingAppraisal = 'Pending Appraisal',
    seeDealer = 'See Dealer'
}

export enum VEHICLE_DETAILS_LABELS {
    condition = 'Condition'
}

export enum LOAN_STATUS {
    YES = 'Yes',
    NO = 'No'
}

export enum ButtonText {
    ContinueToSummary = 'Continue to Summary',
    Continue = 'Continue',
    EstimateLoanBalance = 'Estimate Loan Balance'
}

export enum validationMessages {
    selectLoanStatus = 'Please select whether you have an open loan balance.'
}
export const EQUIPMENT_OPTION_DEBOUNCE_MS = 500;
